import PageView from '@/layouts/PageView';

/**
 * 动态路由列表
 * 1、载入前会用根据用户权限列表，移除该用户不具备的权限
 * 2、该列表会生成主菜单，meta: {invisible:true}则表示不显示在主菜单，目前最多生成2级菜单
 */

export const routerList = [
	{
		path: '/member',
		name: '用户管理',
		meta: {
			icon: 'user'
		},
		component: PageView,
		children: [{
			path: '/member/user/userList',
			name: '用户列表',
			component: () => import('@/pages/member/user/UserList')
		}, {
			path: '/member/user/userDetail',
			name: '用户详情',
			meta: { invisible: true },
			component: () => import('@/pages/member/user/UserDetail')
		}, {
			path: '/member/actorList',
			name: '聊客列表',
			component: () => import('@/pages/member/actor/ActorList')
		},
		{
			path: '/member/performerList',
			name: '演员列表',
			meta: { invisible: true },
			component: () => import('@/pages/member/performer/PerformerList')
		}]
	},
	{
		path: '/operate',
		name: '运营支撑',
		meta: {
			icon: 'profile'
		},
		component: PageView,
		children: [
			{
				path: '/op/moderateList',
				name: '审核任务',
				component: () => import('@/pages/op/moderate/ModerateList')
			},
			{
				path: '/op/actionLogList',
				name: '行为日志',
				component: () => import('@/pages/op/log/ActionLogList')
			},
			{
				path: '/op/violateWordList',
				name: '审核关键词',
				component: () => import('@/pages/op/violate_word/ViolateWordList')
			},
			{
				path: '/op/riskWordList',
				name: '风险词管理',
				component: () => import('@/pages/op/risk_word/RiskWordList')
			},
			{
				path: '/op/userGoldList',
				name: '金币流水',
				component: () => import('@/pages/op/user/UserGoldList')
			},
			{
				path: '/op/userScoreList',
				name: '积分流水',
				component: () => import('@/pages/op/user/UserScoreList')
			},
			{
				path: '/op/callList',
				name: '通话记录',
				component: () => import('@/pages/op/call/CallList')
			},
			{
				path: '/op/productOrderList',
				name: '订单列表',
				component: () => import('@/pages/op/product_order/ProductOrderList')
			},
			{
				path: '/op/userTransferList',
				name: '提现列表',
				component: () => import('@/pages/op/user_transfer/UserTransferList')
			},
			{
				path: '/op/conversationList',
				name: '会话列表',
				component: () => import('@/pages/op/conversation/ConversationList')
			},
			{
				path: '/op/messageList',
				name: '聊天记录',
				component: () => import('@/pages/op/message/MessageList')
			}
		]
	},
	{
		path: '/content',
		name: '内容管理',
		meta: {
			icon: 'profile'
		},
		component: PageView,
		children: [
			{
				path: '/content/momentList',
				name: '日常管理',
				component: () => import('@/pages/content/moment/MomentList')
			},
			{
				path: '/content/pageList',
				name: '单页列表',
				component: () => import('@/pages/content/page/PageList')
			},
			{
				path: '/content/helpPageList',
				name: '帮助中心',
				component: () => import('@/pages/content/help_page/HelpPageList')
			},
			{
				path: '/content/accostTplList',
				name: '搭讪消息',
				component: () => import('@/pages/content/accost/AccostList')
			},
			{
				path: '/content/giftList',
				name: '礼物管理',
				component: () => import('@/pages/content/gift/GiftList')
			},
			{
				path: '/content/taskList',
				name: '任务管理',
				component: () => import('@/pages/content/task/TaskList')
			}
		]
	},
	{
		path: '/system',
		name: '系统管理',
		meta: {
			icon: 'setting',
			title: 'menu.system'
		},
		component: PageView,
		children: [{
				path: '/system/adminList',
				name: '管理员列表',
				component: () => import('@/pages/system/admin/AdminList')
			},
			{
				path: '/system/roleList',
				name: '角色列表',
				component: () => import('@/pages/system/role/RoleList')
			},
			{
				path: '/system/funcList',
				name: '资源列表',
				component: () => import('@/pages/system/func/FuncList')
			},
			{
				path: '/system/config',
				name: '系统配置',
				component: () => import('@/pages/system/config/Config')
			},
			{
				path: '/system/tagList',
				name: '标签管理',
				component: () => import('@/pages/system/tag/TagList')
			},
			
			{
				path: '/system/productList',
				name: '商品列表',
				meta: { title: 'menu.system.product-list' },
				component: () => import('@/pages/system/product/ProductList')
			},
			{
				path: '/system/professionList',
				name: '职业管理',
				component: () => import('@/pages/system/profession/ProfessionList')
			},
			
			{
				path: '/system/cacheItems',
				name: '缓存管理',
				meta: { title: 'menu.system.cache-manage' },
				component: () => import('@/pages/system/cache/CacheManage')
			}
		]
	}
]